import NiceModal, { useModal } from '@ebay/nice-modal-react'

import closeModal from '../../utils/closeModal'
import Modal from './modal'
interface BannerPopupModalProps {
  imgUrl: string
  onClick?: () => void
}

const BannerPopupModal = ({ imgUrl, onClick }: BannerPopupModalProps) => {
  const modal = useModal()

  return (
    <Modal
      id="banner-popup-modal"
      containerStyle="flex p-0 border-transparent bg-transparent max-w-[500px]"
      zIndex={340}>
      <img
        src={imgUrl}
        alt="Banner"
        onClick={onClick ? onClick : () => closeModal(modal)}
        className="w-full aspect-square rounded-[10px] lg:rounded-[20px] cursor-pointer"
      />
    </Modal>
  )
}

export default NiceModal.create(BannerPopupModal)
